<dx-popup [visible]="isPopupVisible" [showTitle]="false" [width]="'95%'" [maxWidth]="650" [height]="'auto'"
  [maxHeight]="'90vh'" (onHiding)="closePopup()">
  <div *dxTemplate="let data of 'content'" class="popup-container">
    <!-- Header -->
    <div class="popup-header">
      <h2 class="popup-title">Add Holiday</h2>
      <button class="close-btn" (click)="closePopup()">
        <i class="dx-icon-close"></i>
      </button>
    </div>

    <!-- Subtitle / Description -->
    <p class="popup-description">
      Add one or more holidays for the year in one go. Each row can span a date
      range (e.g., a 3-day Eid holiday) — use "Add Another Row" to set up
      several holidays at once.
    </p>

    <!-- Table Container -->
    <div class="table-card">
      <div class="table-header desktop-only">
        <div class="col-date">FROM DATE</div>
        <div class="col-date">TO DATE</div>
        <div class="col-event">EVENT NAME</div>
        <div class="col-action"></div>
      </div>

      <!-- Scrollable Container for Rows -->
      <div class="scrollable-table-body">
        <div *ngFor="let row of holidayRows; let i = index" class="table-row">
          <!-- Mobile Delete Button Position -->
          <div class="mobile-row-header mobile-only">
            <span class="row-index">Holiday #{{ i + 1 }}</span>
            <button class="remove-row-btn" (click)="removeRow(i)" [disabled]="holidayRows.length === 1">
              <i class="dx-icon-close"></i>
            </button>
          </div>

          <!-- From Date -->
          <div class="col-date">
            <label class="mobile-label mobile-only">From Date</label>
            <dx-date-box [(ngModel)]="row.fromDate" type="date" displayFormat="dd/MM/yyyy" placeholder="dd/mm/yyyy"
              [min]="minDate" stylingMode="outlined" class="custom-input" [dropDownOptions]="editorDropDownOptions">
            </dx-date-box>
          </div>

          <!-- To Date -->
          <div class="col-date">
            <label class="mobile-label mobile-only">To Date</label>
            <dx-date-box [(ngModel)]="row.toDate" type="date" displayFormat="dd/MM/yyyy" placeholder="dd/mm/yyyy"
              [min]="row.fromDate || minDate" stylingMode="outlined" class="custom-input"
              [dropDownOptions]="editorDropDownOptions">
            </dx-date-box>
          </div>

          <!-- Event Name -->
          <!-- Event Name -->
          <div class="col-event">
            <label class="mobile-label mobile-only">Event Name</label>

            <dx-select-box [dataSource]="holidayEvents" valueExpr="id" displayExpr="name" [(ngModel)]="row.eventId"
              (onValueChanged)="onEventChanged($event, row)" placeholder="Select an event/reason..."
              stylingMode="outlined" class="custom-input" [dropDownOptions]="editorDropDownOptions">
            </dx-select-box>

            <!-- Show textbox only when Others is selected -->
            <input *ngIf="isOthersEvent(row.eventId)" type="text" [(ngModel)]="row.eventReason"
              placeholder="Type the event/reason..." class="event-reason-input" maxlength="250" />
          </div>

          <!-- Desktop Remove Row Button -->
          <div class="col-action desktop-only">
            <button class="remove-row-btn" (click)="removeRow(i)" [disabled]="holidayRows.length === 1">
              <i class="dx-icon-close"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Fixed Footer Actions Below -->
    <div class="add-row-container">
      <button class="add-row-btn" (click)="addNewRow()">
        + Add Another Row
      </button>
    </div>

    <div class="popup-actions">
      <dx-button text="Cancel" class="themeButtonWhite" (onClick)="closePopup()"></dx-button>
      <dx-button text="Save All Holidays" class="themeButton" (onClick)="saveAllHolidays()"></dx-button>
    </div>
  </div>
</dx-popup>